<template>
  <q-layout view="hHh Lpr lff" class="custom-font">
    <q-header elevated>
      <q-toolbar class="pragma-black">
        <q-btn
          flat
          dense
          round
          icon="menu"
          aria-label="Menu"
          @click="toggleLeftDrawer"
        />

        <q-toolbar-title>
          <div class="row">
            <div class="col-xs-12 text-center">
              <span class="text-subtitle1">REPORTES</span> <br>
            </div>
            <div class="col-xs-12 text-center text-grey">
              <q-icon name="person"></q-icon><span class="text-subtitle2"> Presidencia</span> <br>
            </div>
          </div>
          
          
        </q-toolbar-title>
        <q-btn
          class="pragma-black pragma-text-black"
          flat
          v-if="route.name === 'searchAprobar'"
          icon="more_vert"
        ></q-btn>
        <q-btn flat color="white" icon="more_vert" v-if="route.name !== 'searchAprobar'">
          <!-- <q-menu class="bg-pragma-secon custom-font">
            <q-list style="min-width: 180px" dark separator dense>
              <q-item
                clickable
                v-close-popup
                @click="changePage(section)"
                v-for="section in sections"
                :key="section.name"
              >
                <div class="row full-width flex flex-center">
                  <div class="col-xs-2" :style="`color: #${section.color}`">
                    <q-icon name="circle"></q-icon>
                  </div>
                  <div class="col-xs-8">
                    {{ section.name }}
                  </div>
                </div>
              </q-item>
            </q-list>
          </q-menu> -->
        </q-btn>

      </q-toolbar>
    </q-header>
    
    <q-drawer
      v-model="show_drawer"
      :width="250"
      class="bg-blue-grey text-white"
    >
      <bar-menu-presidencia />
    </q-drawer>
    <q-page-container>
      <router-view v-slot="{ Component }">
        <transition name="fade">
          <component :is="Component" />
        </transition>
      </router-view>
    </q-page-container>
  </q-layout>
</template>

<script>
// import axios from 'axios'
import {inject, ref} from 'vue'
// import {useQuasar} from 'quasar'

import util from '../../plugins/util'
import { useRoute } from 'vue-router'
import BarMenuPresidencia from '../../components/BarMenuPresidencia.vue'

export default {
  name: 'MainLayout',
  components: {
    BarMenuPresidencia
  },
  setup () {
    // Variables reactivas y no reactivas
    // const $q = useQuasar()
    const bus = inject('bus')
    // const router = useRouter()
    const route = useRoute()

    const show_drawer = ref(false)
    const title = ref({
      empresa: '',
      gestion: ''
    })
    const sections = ref([
      {
        name: 'CREADAS',
        title: 'SOLICITUDES CREADAS',
        link: 'solicitudes-admin/creadas',
        color: '9B59B6'
      },
      {
        name: 'REVISADAS',
        title: 'SOLICITUDES REVISADAS',
        link: 'solicitudes-admin/autorizadas',
        color: 'F6B855'
      },
      {
        name: 'PARA APROBAR',
        title: 'APROBAR SOLICITUDES',
        link: 'solicitudes/admin',
        color: '1ABB9C'
      },
      {
        name: 'TRANSFERENCIAS',
        title: 'SOLICITUDES DE TRANSFERENCIA',
        link: 'solicitudes-admin/transf_tesoreria',
        color: '50C1CF'
      },
      {
        name: 'PEN - 1',
        title: 'SOLICITUDES PENDIENTES 1',
        link: 'solicitudes-admin/pendientes1',
        color: 'ffcc66'
      },
      {
        name: 'PEN - 2',
        title: 'SOLICITUDES PENDIENTES 2',
        link: 'solicitudes-admin/pendientes2',
        color: 'ffcc66'
      },
      {
        name: 'PEN - 3',
        title: 'SOLICITUDES PENDIENTES 3',
        link: 'solicitudes-admin/pendientes3',
        color: 'ffcc66'
      },
      {
        name: 'PEN - 4',
        title: 'SOLICITUDES PENDIENTES 4',
        link: 'solicitudes-admin/pendientes4',
        color: 'ffcc66'
      },
      {
        name: 'PEN - 5',
        title: 'SOLICITUDES PENDIENTES 5',
        link: 'solicitudes-admin/pendientes5',
        color: 'ffcc66'
      },
      {
        name: 'PEN - 6',
        title: 'SOLICITUDES PENDIENTES 6',
        link: 'solicitudes-admin/pendientes6',
        color: 'ffcc66'
      },
      {
        name: 'PEN - 7',
        title: 'SOLICITUDES PENDIENTES 7',
        link: 'solicitudes-admin/pendientes7',
        color: 'ffcc66'
      },
      {
        name: 'PEN - 8',
        title: 'SOLICITUDES PENDIENTES 8',
        link: 'solicitudes-admin/pendientes8',
        color: 'ffcc66'
      },
      {
        name: 'PEN - 9',
        title: 'SOLICITUDES PENDIENTES 9',
        link: 'solicitudes-admin/pendientes9',
        color: 'ffcc66'
      },
      {
        name: 'PEN - 10',
        title: 'SOLICITUDES PENDIENTES 10',
        link: 'solicitudes-admin/pendientes10',
        color: 'ffcc66'
      },
      {
        name: 'PEN - 11',
        title: 'SOLICITUDES PENDIENTES 11',
        link: 'solicitudes-admin/pendientes11',
        color: 'ffcc66'
      },
      {
        name: 'PEN - 12',
        title: 'SOLICITUDES PENDIENTES 12',
        link: 'solicitudes-admin/pendientes12',
        color: 'ffcc66'
      },
      {
        name: 'TESORERIA',
        title: 'SOLICITUDES TESORERIA',
        link: 'solicitudes-admin/tesoreria',
        color: '50C1CF'
      },
      {
        name: 'RECHAZADAS',
        title: 'SOLICITUDES RECHAZADAS',
        link: 'solicitudes-admin/rechazadas',
        color: '50AACF'
      },
      {
        name: 'RECHAZADAS TESORERIA',
        title: 'SOLICITUDES RECHAZADAS POR TESORERIA',
        link: 'solicitudes-admin/rechazadas-tesoreria',
        color: '50AACF'
      },
      {
        name: 'TODAS',
        title: 'TODAS LAS SOLICITUDES',
        link: 'solicitudes-admin/todas',
        color: 'AAC1CF'
      }
    ])

    // Métodos y funciones
    const changePage = (section) => {
      bus.emit('changePage', section)
    }

    // Creación del componente
    // Limpieza de eventos
    bus.all.clear()
    util.verifyRol([8]) // Roles permitidos
    
    // Retorno de variables de la plantilla
    return {
      show_drawer,
      toggleLeftDrawer () {
        show_drawer.value = !show_drawer.value
      },
      title,
      changePage,
      route,
      sections
    }
  }
}
</script>

<style>
.estados {
  min-width: 40px;
}
</style>